<template>
  <v-menu bottom offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        icon
        elevation="0"
        dark
        text
        color="defaultColor"
        v-bind="attrs"
        v-on="on"
        class="text-capitalize"
        :style="`margin-top: ${marginTop}px`"
      >
        😊
      </v-btn>
    </template>
    <template>
      <VEmojiPicker :showSearch="false" @select="selectEmoji" />
    </template>
  </v-menu>
</template>

<script>
import { VEmojiPicker } from "v-emoji-picker";
export default {
  data() {
    return {
      openEmojiPickerDialog: false,
    };
  },
  props: {
    item: Object,
    marginTop:{
        type:Number,
        default:0
    }
  },
  mounted() {},
  methods: {
    selectEmoji(emoji) {
        this.$emit('selectEmoji', emoji)
    },
  },
  components: {
    VEmojiPicker,
  },
  computed: {},
};
</script>
